import axios from 'axios'
import queryString from 'query-string'
import { getResponseData } from 'src/queries/network.utils'
import type {
  AdditionalFieldsFiltersRequestParams,
  AdditionalFieldsResponse,
} from 'src/queries/organizations/additionalFields.queries'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export interface GetAdditionalFieldsResponse {
  expenseAdditionalFields: AdditionalFieldsResponse[]
}

export const getAdditionalFields = async (
  filters: AdditionalFieldsFiltersRequestParams,
): Promise<GetAdditionalFieldsResponse> =>
  getResponseData(
    axios.get<GetAdditionalFieldsResponse>(
      `/expensedata/additionalfields${filters ? `?${queryString.stringify(filters)}` : ``}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
